import {
  TICKET_FETCH_SUCCESS,
  TICKET_FETCH_RESET,
  TICKETS_FETCH_SUCCESS,
  TICKETS_FETCH_RESET,
  TICKET_STATUS_FETCH_SUCCESS,
  TICKET_STATUS_FETCH_RESET,
} from '../actions/types';

const INIT_STATE = {
  ticket: {},
  tickets: [],
  status: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TICKETS_FETCH_SUCCESS: {
      return {
        ...state,
        ticket: {},
        tickets: action.payload,
      };
    }
    case TICKETS_FETCH_RESET: {
      return {
        ...state,
        tickets: [],
      };
    }
    case TICKET_FETCH_SUCCESS: {
      return {
        ...state,
        ticket: action.payload,
      };
    }
    case TICKET_FETCH_RESET: {
      return {
        ...state,
        ticket: {},
      };
    }
    case TICKET_STATUS_FETCH_SUCCESS: {
      return {
        ...state,
        status: action.payload,
      };
    }
    case TICKET_STATUS_FETCH_RESET: {
      return {
        ...state,
        status: [],
      };
    }
    default:
      return state;
  }
};
